import { render, staticRenderFns } from "./LegacyMobilePortfolioDialog.vue?vue&type=template&id=a22cc836&scoped=true&"
import script from "./LegacyMobilePortfolioDialog.vue?vue&type=script&lang=js&"
export * from "./LegacyMobilePortfolioDialog.vue?vue&type=script&lang=js&"
import style0 from "./LegacyMobilePortfolioDialog.vue?vue&type=style&index=0&id=a22cc836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22cc836",
  null
  
)

export default component.exports